import PageHeader from '../../../../../components/templates/pageHeader/PageHeader';
import OurGraduation from '../../../../../components/templates/aboutTheAcademyTemplate/outlet/graduation/OurGraduation/OurGraduation';
import { navigationLinks } from '../../../factory/data';

import CardsSections from '../sections/cardsSection/CardsSections';
const imageBackground = '/images/about-academy/aboutTheAcademyHistory.png';
// const video = '/assets/videos/history/1988.mp4';
// const video1978 = '/assets/videos/history/1978.mp4';
// const video2005 = '/assets/videos/history/2005.mp4';
// const video2022 = '/assets/videos/history/2022.mp4';
// const historyVideo = '/assets/videos/history/history-Montage.mp4';

const data = {
  img: imageBackground,
  title: 'About_The_Academy.title',
  subtext: 'History.History_subtitle',
};
const years = [
  {
    year: 1968,
    barSize: false,
  },
  { year: 1970, barSize: true },
  { year: 1978, barSize: true, hasVideo: true },
  { year: 1979, barSize: false },
  { year: 1980, barSize: true },
  { year: 1987, barSize: true, hasVideo: true },
  { year: 1991, barSize: false },
  { year: 2005, barSize: true, hasVideo: true },
  { year: 2010, barSize: true },
  { year: 2017, barSize: false },
  { year: 2018, barSize: false },
  // { year: 2021, barSize: true },
  { year: 2021, barSize: true, hasVideo: true },
];
const getImage = (path) => `/images/history/${path}`;
const getMobile = (path) => `/images/history/mobile/${path}`;
const historyVideo = '/videos/history/history-Montage.mp4';

/*
 * Note regarding the 'id' field in the array elements:
 * Ignore the id here, the id is generated from the index of the array
 */
const parallaxSections = [
  {
    id: 0,
    component: PageHeader,
    data,
    navigationData: navigationLinks,
    backdrop: true,
  },
  {
    id: 1,
    component: OurGraduation,
    videoUrl: historyVideo,
    isAnimated: true,
    title: 'common.our_history',
    singleWord: true,
  },
  {
    backgroundImage: getImage('1966/one_intro.png'),
    title: 'History.intro_speech',
    text: '',
    backgroundColor: 'black',
    id: 2,
  },
  {
    year: 1968,
    backgroundImage: getImage('1966/one_main.png'),
    foregroundImage: getImage('1966/one.png'),
    isLottie: true,
    mobileImage: getMobile('1968-m-1.png'),
    lottieCLassname: 'defaultInner',
    sideModal: {
      text: 'History.1966Text',
      buttonText: 'History.law1966',
      image: getImage('1966/law.png'),
    },
    id: 2,
  },
  {
    year: 1968,
    backgroundImage: getImage('1966/one_intro.png'),
    mobileImage: getMobile('1968-m-bg-1.png'),
    text: 'History.1968Text',
    title: 'History.1968',
    id: 2,
    isLineBreak: true,
  },
  {
    year: 1968,
    backgroundImage: getImage('1966/id3_1966.png'),
    mobileImage: getMobile('1970-m-bg-1.png'),
    sectionClass: 'twoIntro',
    text: 'History.twoIntro',
    id: 1,
  },
  {
    year: 1968,
    backgroundImage: getImage('1966/id3_1966.png'),
    foregroundImage: getImage('1966/id4_1966_front.png'),
    mobileImage: getMobile('1968-m-2.png'),
    classname: 'img1988m4',
    isLottie: true,
    id: 4,
  },
  {
    year: 1970,
    backgroundImage: getImage('1970/id5_1970_background.png'),
    mobileImage: getImage('1970/mobile/1970-bg.png'),
    text: 'History.threeIntro',
    title: 'History.1970',
    id: 3,
  },
  {
    year: 1970,
    // backgroundImage: getImage('1970/id5_1970_background.png'),
    foregroundImage: getImage('1970/1970.jpeg'),
    mobileImage: getMobile('1980-front.png'),
    classname: 'img1970m4',
    isLottie: true,
    id: 4,
  },
  {
    year: 1978,
    title: 'History.1978_title',
    hasVideo: '/videos/history/1978.mp4',
    // title: 'History.1978',
    classname: 'img1988m4',

    id: 5,
  },
  {
    year: 1978,
    backgroundImage: getImage('1978/id9_1978_background.png'),
    mobileImage: getImage('1978/id9_1978_background.png'),
    text: 'History.fourIntro',
    classname: 'img1988m4',
    id: 6,
  },

  {
    year: 1978,
    backgroundImage: getImage('1978/id9_1978_background.png'),
    foregroundImage: getImage('1978/id9_1978_front.png'),
    mobileImage: getImage('mobile/1978-m-1.png'),
    id: 7,
  },

  {
    year: 1978,
    backgroundImage: getImage('1980/id11_1980_background.png'),
    foregroundImage: getImage('1980/id11_1980_front.png'),
    mobileImage: getImage('mobile/sheikh.png'),
    isLottie: true,
    id: 9,
  },

  {
    year: 1979,
    backgroundImage: getImage('1988/id12_1988_background.png'),
    mobileImage: getImage('1978/mobile/1978-bg-3.png'),
    text: 'History.sixIntro',
    title: 'History.1979-1980',
    classname: 'img1988m4',
    id: 10,
  },

  {
    year: 1979,
    backgroundImage: getImage('1988/id14_1988_background.png'),
    foregroundImage: getImage('1988/id14_1988_front.png'),
    mobileImage: getMobile('1978-m-3.png'),
    isLottie: true,
    classname: 'img1978m1',
    id: 9,
  },
  {
    year: 1979,
    backgroundImage: getImage('1988/id15_1988_background.png'),
    foregroundImage: getImage('1988/id15_1988_front.png'),
    mobileImage: getImage('mobile/1979-m-1.png'),
    tabletImage: getImage('mobile/1979-1-tablet.png'),
    onTabletClassname: 'reCenterImageOneTablet',
    classname: 'reCenterImageOneMobile',
    id: 9,
  },
  {
    year: 1979,
    backgroundImage: getImage('1988/id16_1988_background.png'),
    foregroundImage: getImage('1988/id16_1988_front.png'),
    mobileImage: getImage('mobile/1979-m-2.png'),
    id: 9,
  },

  //// END OF 1978

  {
    year: 1980,
    backgroundImage: getImage('1991/id17_1991_background.png'),
    mobileImage: getImage('1980/mobile/1980-bg.png'),
    text: 'History.nineSection',
    classname: 'img1988m4',
    id: 11,
  },
  {
    year: 1980,
    backgroundImage: getImage('1991/id17_1991_background.png'),
    foregroundImage: getImage('1991/id18_1991_front.png'),
    mobileImage: getMobile('/1980-m-1.png'),
    id: 12,
  },
  {
    year: 1980,
    backgroundImage: getImage('2005/id19_2005_background.png'),
    foregroundImage: getImage('2005/id19_2005_front.png'),
    mobileImage: getImage('mobile/1980-m-2.png'),
    id: 14,
  },
  //// END OF 1980
  {
    year: 1987,
    hasVideo: '/videos/history/1988.mp4',
    title: 'History.1987–1988',
    classname: 'img1988m4',
    id: 15,
  },
  {
    year: 1987,
    backgroundImage: getImage('2005/id20_2005_background.png'),
    text: 'History.elevenSection',
    mobileImage: getImage('1988/mobile/1988-bg.png'),
    classname: 'img1988m4',
    id: 16,
  },
  {
    year: 1987,
    backgroundImage: getImage('2005/id21_2005_background.png'),
    foregroundImage: getImage('2005/id21_2005_front.png'),
    mobileImage: getImage('mobile/1988-m-1.png'),
    lottieImage: getImage('1988/History_61.png'),
    classname: 'img1988m4',
    isLottie: true,
    id: 17,
  },
  {
    year: 1987,
    backgroundImage: getImage('2005/twelve_bg.png'),
    text: 'History.twelveIntro',
    mobileImage: getImage('1988/mobile/1988-bg-2.png'),
    classname: 'img1988m4',
    isBackdrop: true,
    id: 18,
  },
  {
    year: 1987,
    backgroundImage: getImage('2005/twelve_bg.png'),
    foregroundImage: getImage('2005/id22_2005_front.png'),
    mobileImage: getImage('mobile/1988-m-2.png'),
    classname: 'img1988m2',
    isBackdrop: true,
    isLottie: true,
    id: 19,
  },

  {
    year: 1987,
    backgroundImage: getImage('2018/id29_2018_background.png'),
    foregroundImage: getImage('2018/id29_2018_front.png'),
    mobileImage: getImage('mobile/1988-m-4.png'),
    classname: 'img1988m4',
    sideModal: {
      text: 'History.forteenSection',
      buttonText: 'History.law1987',
      image: getImage('1978/Law1978.png'),
    },
    id: 20,
  },
  {
    id: 21,
    year: 1987,
    component: CardsSections,
  },
  {
    year: 1987,
    backgroundImage: getImage('2010/id28_2010_background.png'),
    foregroundImage: getImage('2010/id28_2010_front.png'),
    mobileImage: getImage('mobile/1988-m-3.png'),
    tabletImage: getImage('mobile/1988-3.png'),
    uniqueId: 'reShapeImageOneMobile',
    id: 26,
  },

  //// END OF 1988
  {
    year: 1991,
    backgroundImage: getImage('2018/id30_2018_background.png'),
    mobileImage: getImage('mobile/1991-m-bg-1.png'),
    tabletImage: getImage('mobile/1991-bg.png'),
    classname: 'img1988m4',
    text: 'History.seventeenIntro',
    title: 'History.1991',
    id: 28,
  },
  {
    year: 1991,
    backgroundImage: getImage('2018/fifteen_bg.png'),
    foregroundImage: getImage('2018/id30_2018_front.png'),
    mobileImage: getImage('mobile/1991-m-bg-1.png'),
    tabletImage: getImage('mobile/1991-1.png'),
    classname: 'img1988m4',
    id: 29,
  },
  {
    year: 2005,
    hasVideo: '/videos/history/2005.mp4',
    title: 'History.2005',
    classname: 'img1988m4',
    id: 32,
  },
  {
    year: 2005,
    backgroundImage: getImage('2005/firstBackground2005.png'),
    text: 'History.sixteenIntro',
    innerLaw: {
      text: 'History.law2005',
      image: getImage('2005/Law2005.png'),
    },
    mobileImage: getImage('2005/mobile/2005-bg.png'),
    classname: 'img1988m4',
    id: 30,
  },
  {
    year: 2005,
    backgroundImage: getImage('2005/firstBackground2005.png'),
    text: 'History.sixteenIntro2',
    subtext: 'History.sixteenIntro_article',
    mobileImage: getImage('2005/mobile/2005-bg.png'),
    id: 30,
  },
  {
    year: 2005,
    backgroundImage: getImage('2005/firstBackground2005.png'),
    foregroundImage: getImage('2005/firstFront2005.png'),
    mobileImage: getMobile('/2018-m-2.png'),
    id: 30,
  },
  //// END OF 2005
  {
    year: 2010,
    backgroundImage: getImage('2010/seventeen_intro.png'),
    title: 'History.twelveTitle',
    text: 'History.twelveIntro',
    mobileImage: getMobile('/1968-m-bg-2.png'),
    id: 35,
  },
  {
    year: 2010,
    backgroundImage: getImage('2010/seventeen_bg.png'),
    foregroundImage: getImage('2010/seventeen.png'),
    mobileImage: getImage('2010/mobile/2010-bg.png'),
    classname: 'mobile_2010_background1',
    isBackdrop: true,
    id: 36,
  },
  {
    year: 2017,
    backgroundImage: getImage('2018/eighteen_intro.png'),
    title: 'History.eighteenTitle',
    text: 'History.eighteenIntro',
    mobileImage: getImage('2018/mobile/2018-bg.png'),
    classname: 'img1988m4',
    isBackdrop: true,
    id: 38,
  },
  {
    year: 2017,
    backgroundImage: getImage('2018/eighteen_bg2.png'),
    foregroundImage: getImage('2018/2017-1.png'),
    mobileImage: getImage('mobile/2018-m-1.png'),
    classname: 'img2018m1',
    id: 39,
  },
  {
    year: 2018,
    backgroundImage: getImage('2018/nineteen_bg.png'),
    title: 'History.nineteenTitle',
    text: 'History.nineteenIntro',
    mobileImage: getImage('2018/mobile/2018-bg-2.png'),
    classname: 'img1988m4',
    isBackdrop: true,
    id: 40,
  },
  {
    year: 2018,
    backgroundImage: getImage('2018/nineteen_bg.png'),
    foregroundImage: getImage('2018/nineteen.png'),
    mobileImage: getImage('2018/mobile/2018-2.png'),
    classname: 'img1988m4',
    id: 41,
  },

  //// END OF 2018
  {
    year: 2021,
    hasVideo: '/videos/history/2022.mp4',
    title: 'History.2021',
    classname: 'img1988m4',
    id: 42,
  },
  {
    year: 2021,
    backgroundImage: getImage('2022/twenty_intro.png'),
    title: 'History.twentyTitle',
    text: 'History.twentyIntro',
    mobileImage: getImage('2022/mobile/2022-bg.png'),
    classname: 'img1988m4',
    id: 44,
  },
  {
    year: 2021,
    backgroundImage: getImage('2022/twenty_intro.png'),
    foregroundImage: getImage('2022/frontImage2022.png'),
    mobileImage: getMobile('2022-m-1.png'),
    classname: 'mobile_2022_background3',
    id: 44,
  },
];

const sections2010 = [];
export { parallaxSections, years, sections2010 };
